import React, {FC} from 'react'
import styled from '@emotion/styled'

import {Icon} from '@vio/atlas/Icon'
import {cssTheme} from '@vio/atlas/themes'

import {getHighlightIcon} from './themes'
import {PropertyHighlight} from './types'

const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: ${cssTheme.layout.spacing.s250} ${cssTheme.layout.spacing.s400};
  margin: 0;
  padding: ${cssTheme.layout.spacing.s200} 0 0;
  list-style: none;
`

const Item = styled.li<{secondary?: boolean}>`
  display: flex;
  align-items: flex-start;
  gap: ${cssTheme.layout.spacing.s100};
  min-width: 0;
  color: ${({secondary}) =>
    secondary
      ? cssTheme.colors.content.neutral.secondary
      : cssTheme.colors.content.neutral.primary};
`

const ConciseText = styled.span`
  ${cssTheme.typography.bodyXS};
  overflow-wrap: break-word;
  min-width: 0;
`

interface Props {
  items: PropertyHighlight[]
}

// The card click handlers find this value in the closest data-id.
const getSelectedElement = ({theme}: PropertyHighlight, index: number) =>
  theme === 'location'
    ? 'property-highlight-location'
    : `property-highlight-theme-${index + 1}`

export const PropertyHighlights: FC<Props> = ({items}) => {
  if (items.length === 0) return null

  return (
    <List>
      {items.map((item, index) => (
        <Item
          key={item.theme}
          secondary={item.theme === 'location'}
          data-id={getSelectedElement(item, index)}
        >
          <Icon
            name={getHighlightIcon(item)}
            size="sm"
            colorPath="content.neutral.secondary"
          />
          <ConciseText>{item.concise}</ConciseText>
        </Item>
      ))}
    </List>
  )
}
